import { styled } from "styled-components";
import { px } from "../../utils/px.es.js";
const ALIGN_X_MAP = {
  left: "start",
  center: "center",
  right: "end",
  justify: "space-around"
};
const SPACE_MAP = {
  none: 0,
  small: 8,
  medium: 16,
  large: 24
};
const GridImpl = styled("div")(
  {
    alignItems: "start",
    display: "grid"
  },
  ({ $alignX, $columnWidth }) => ({
    gridTemplateColumns: $alignX === "justify" ? `repeat(auto-fit, minmax(${px($columnWidth)}, 1fr))` : `repeat(auto-fit, ${px($columnWidth)})`,
    justifyContent: ALIGN_X_MAP[$alignX]
  }),
  ({ $space }) => ({
    gap: SPACE_MAP[$space]
  })
);
export {
  GridImpl
};
